import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ArrayHelpers, Loading, SystemText } from 'e4shared';
import { apiGet } from 'services';
import NoResults from 'components/general/noResults';
import { e4Format, e4Formats } from 'helpers/dates';

export const KnowledgeBankQuestions = ({ profileId, range, offset, type }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        const qs = `?range=${range}&offset=${offset}&type=${type}`;
        profileId && apiGet(`questions/${profileId}${qs}`, guid, response => gotResponse(response));
    }, [guid, profileId, range, offset]);

    if (loading) return <Loading />;

    if (!ArrayHelpers.existsAndHasLength(data))
        return (
            <NoResults
                title={SystemText('User121/e4Metrics/Details/Questions/NoResults/Title')}
                message={SystemText('User121/e4Metrics/Details/Questions/NoResults/Message')}
            />
        );

    const slug = type === 'like' ? 'Liked' : type === 'view' ? 'Viewed' : 'Asked';

    return (
        <div>
            {data.map(d => {
                return (
                    <div key={`answer-${d.id}`} className="mb10 flex">
                        <i className="fa fa-question-circle text-success" style={{ fontSize: '30px' }} />
                        <div className="ml20 flex-grow">
                            <div>
                                <b>{SystemText('User121/e4Metrics/Details/Questions/Question')}</b>
                                <br />
                                <Link data-testid="link-question" to={`/knowledge-bank/${d.id}`}>
                                    {d.name}
                                </Link>
                            </div>
                            <div>
                                <b>{SystemText(`User121/e4Metrics/Details/Questions/${slug}`)}</b>
                                <br />
                                {e4Format(d.created)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default KnowledgeBankQuestions;
